import "./src/styles/global.css";
import sal from "sal.js";

/**
 * Discourage casual copying of the artwork.
 *
 * This is a deterrent, not protection. Anything a browser displays has already
 * been downloaded, and can still be taken via devtools, the network tab, a
 * screenshot, or with scripting disabled. What this stops is the easy paths:
 * right-click "Save image as", dragging an image to the desktop, and the iOS
 * long-press save sheet.
 *
 * Delegated from the document so it covers images added by client-side
 * navigation and the slideshow without any per-image wiring.
 */
const MEDIA = "img, video, .gatsby-image-wrapper";

const blockOnMedia = (e) => {
  if (e.target && e.target.closest && e.target.closest(MEDIA)) {
    e.preventDefault();
  }
};

export const onClientEntry = () => {
  if (typeof window === "undefined") return;

  document.addEventListener("contextmenu", blockOnMedia);
  document.addEventListener("dragstart", blockOnMedia);

  // initialise scroll-reveal once the client boots
  window.__sal = sal({ threshold: 0.1, once: true });
};

export const onRouteUpdate = () => {
  // re-scan for [data-sal] elements after client-side navigation
  if (typeof window !== "undefined" && window.__sal && window.__sal.reset) {
    window.__sal.reset({ threshold: 0.1, once: true });
  } else if (typeof window !== "undefined") {
    window.__sal = sal({ threshold: 0.1, once: true });
  }
};
